var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHanhtinh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 567,
    height: 473,
    viewBox: "0 0 567 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1676_9667)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.303 368.394C272.974 406.295 181.967 376.852 144.032 302.6C106.13 228.272 135.574 137.264 209.859 99.2522C284.188 61.3509 375.195 90.7945 413.13 165.046C451.108 239.408 421.631 330.493 347.303 368.394Z",
    fill: "url(#paint0_linear_1676_9667)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M426.879 204.957C420.828 204.12 414.744 203.36 408.77 202.558C399.66 201.379 391.205 199.756 382.786 195.765C374.291 191.74 366.568 186.588 358.947 181.206C350.703 175.365 342.501 169.636 334.469 163.522C306.166 142.04 279.52 115.97 264.734 83.3955C259.684 83.8257 254.608 84.52 249.584 85.5123C253.206 106.188 265.581 125.316 278.409 141.343C302.021 170.751 330.726 195.896 364.072 213.643C379.726 222.02 396.084 229.425 412.754 235.5C417.956 237.429 423.652 239.485 429.44 241.123C430.143 229.143 429.261 217.014 426.879 204.957Z",
    fill: "#FFDBB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M303.166 117.878C310.154 125.732 318.502 132.169 326.315 139.195C332.916 145.227 338.615 152.053 345.114 158.316C366.455 178.742 394.743 197.558 425.138 196.851C422.367 186.09 418.439 175.459 413.174 165.156C387.096 114.115 336.076 84.2555 282.589 82.8394C288.694 94.981 294.119 107.831 303.166 117.878Z",
    fill: "#FFDBB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.629 132.184C247.761 146.154 257.681 157.963 268.801 168.924C276.291 176.266 284.103 183.292 291.882 190.394C299.465 197.318 306.724 204.559 314.587 211.056C328.826 222.845 344.297 232.884 360.845 241.106C381.82 251.558 403.827 259.255 426.13 266.074C427.091 261.82 427.787 257.542 428.407 253.229C426.07 252.29 423.733 251.35 421.431 250.333C407.777 244.49 394.037 238.424 380.553 232.197C356.467 221.106 334.655 206.524 314.413 189.426C294.641 172.719 275.487 154.817 259.156 134.676C251.405 125.018 243.771 114.678 239.006 103.035C237.214 98.5758 235.745 93.8002 235.29 89.0136C230.548 90.4056 225.858 92.0957 221.254 94.007C229.19 105.948 234.2 119.532 240.629 132.184Z",
    fill: "#FFDBB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.285 132.449C177.787 140.949 183.2 148.841 188.834 156.647C193.98 163.688 199.347 170.643 204.749 177.522C210.911 185.378 216.247 193.236 220.954 202.102C225.953 211.554 231.284 220.877 239.259 228.158C247.004 235.338 256.032 241.065 265.051 246.606C282.542 257.262 299.159 269.275 316.896 279.581C334.557 289.853 353.087 300.234 373.514 303.199C386.034 304.965 398.659 305.035 411.296 306.119C413.679 301.76 415.831 297.299 417.754 292.737C417.192 292.764 416.672 292.901 416.076 293.005C407.39 294.398 398.203 296.304 389.391 295.074C371.239 292.564 354.908 282.603 339.686 273.041C323.192 262.825 306.376 252.925 290.086 242.249C273.446 231.327 256.931 219.084 244.564 203.261C230.556 185.337 218.793 165.653 206.86 146.353C201.283 137.38 195.103 129.149 188.871 120.62C187.623 118.876 186.298 117.099 185.083 115.279C180.05 119.202 175.409 123.482 170.965 127.94C171.753 129.48 172.506 131.097 173.285 132.449Z",
    fill: "#FFDBB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M154.324 214.878C158.668 224.775 162.867 234.791 168.828 243.934C173.977 251.802 180.035 259.062 186.705 265.767C193.452 272.506 200.701 278.732 207.839 285.001C215.053 291.304 221.988 298.034 229.236 304.26C242.564 315.83 256.783 326.418 271.877 335.648C295.912 350.386 322.983 362.611 351.182 366.254C356.236 363.533 360.973 360.488 365.591 357.299C356.296 356.956 347.278 355.36 338.478 352.025C311.31 341.683 287.44 324.909 262.926 309.594C246.236 299.2 229.147 289.088 213.968 276.518C197.731 263.021 185.226 246.679 173.094 229.492C161.287 212.816 149.63 194.554 144.945 174.418C144.29 171.745 143.824 169.063 143.357 166.38C141.06 170.961 139.07 175.677 137.233 180.461C143.812 191.528 149.14 203.143 154.324 214.878Z",
    fill: "#FFDBB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M280.674 378.05C242.491 371.467 211.265 346.218 183.759 320.227C175.929 312.826 168.574 305.177 162.478 296.341C156.176 287.139 150.895 277.287 146.499 267.092C139.542 251.273 134.133 234.853 128.249 218.681C125.346 246.657 130.309 275.72 144.033 302.598C175.71 364.64 244.392 395.418 309.478 381.777C299.917 380.583 290.22 379.695 280.674 378.05Z",
    fill: "#FFDBB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M413.173 165.157C375.238 90.9054 284.188 61.3512 209.902 99.3631C135.651 137.298 106.096 228.349 144.108 302.634C182.044 376.886 273.094 406.44 347.379 368.428C421.631 330.493 451.108 239.408 413.173 165.157ZM175.302 273.94C143.839 212.451 168.287 137.123 229.742 105.737C291.308 74.3081 366.594 98.6455 398.022 160.211C429.408 221.666 405.037 297.029 343.582 328.415C282.016 359.843 206.687 335.395 175.302 273.94Z",
    fill: "#E28481"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M154.851 167.144C174.311 134.279 196.234 115.158 214.864 104.121C214.897 104.045 215.008 104.002 215.008 104.002C220.757 100.12 226.755 96.7139 232.924 93.7507C211.123 100.544 179.285 116.572 154.666 154.681C113.016 219.114 136.327 287.643 158.243 316.945C158.243 316.945 109.678 243.504 154.851 167.144Z",
    fill: "#FCD7B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.61 403.056C491.316 383.724 470.343 333.377 424.258 274.054C423.203 277.899 421.994 281.676 420.632 285.386C449.706 325.276 462.352 357.089 451.112 369.461C440.62 380.972 411.396 373.207 373.355 351.554C339.102 332.122 297.775 301.497 256.208 263.521C212.045 223.115 176.187 181.972 153.952 148.403C132.154 115.301 123.553 89.4926 133.442 78.7251C144.079 67.0952 174.036 75.275 213.093 97.7441C216.803 95.9884 220.479 94.3094 224.207 92.9284C164.171 55.2371 115.158 40.5711 98.0214 59.2371C81.4204 77.3139 98.7256 122.465 138.706 176.708C163.582 210.526 197.301 247.79 237.143 284.271C274.552 318.577 312.296 347.345 346.461 368.847C407 406.852 456.44 421.798 473.61 403.056Z",
    fill: "url(#paint1_linear_1676_9667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.686 68.6487C163.081 65.3945 135.343 58.8363 126.582 74.3206C118.796 88.2179 129.848 106.396 136.439 118.476C137.628 120.56 138.817 122.645 140.007 124.729C128.98 103.169 126.051 86.7429 133.476 78.648C144.113 67.0182 174.07 75.198 213.127 97.6671C216.837 95.9113 220.513 94.2323 224.241 92.8514C211.459 84.8244 199.106 77.9038 187.48 72.0377C184.034 70.7004 180.411 69.5594 176.686 68.6487Z",
    fill: "url(#paint2_linear_1676_9667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.598 285.461C449.672 325.352 462.318 357.165 451.078 369.537C442.192 379.28 419.87 375.204 390.169 360.626C395.734 364.642 401.511 368.384 407.322 372.05C414.762 376.802 423.526 382.505 432.584 383.385C441.412 384.163 453.15 383.751 458.496 375.38C466.286 363.135 462.14 347.181 458.401 334.249C455.926 325.728 452.677 317.507 449.317 309.328C442.056 298.144 433.754 286.408 424.344 274.275C423.203 277.898 421.918 281.642 420.598 285.461Z",
    fill: "url(#paint3_linear_1676_9667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.973 83.5668C196.973 83.5668 130.75 38.2835 107.076 62.4096C83.4365 86.4591 124.777 159.646 213.424 253.44C213.424 253.44 118.32 146.432 111.499 96.6456C104.711 46.7829 149.969 58.3234 196.973 83.5668Z",
    fill: "#FCD1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.377 380.402C472.545 351.866 449.064 320.498 449.064 320.498C449.064 320.498 479.975 383.028 447.094 384.38C419.725 385.505 384.157 368.428 357.724 352.266C359.406 353.65 361.088 355.034 362.88 356.376C398.018 378.582 461.495 412.84 467.377 380.402Z",
    fill: "#FCD1C2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1676_9667",
    x1: 380.568,
    y1: 111.703,
    x2: 185.225,
    y2: 345.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0476,
    stopColor: "#CF9D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2034,
    stopColor: "#EFB072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4598,
    stopColor: "#C99080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    stopColor: "#CD9786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5492,
    stopColor: "#D6AA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6119,
    stopColor: "#E6CAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6243,
    stopColor: "#EAD1B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6554,
    stopColor: "#D8B69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7143,
    stopColor: "#BA8870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7735,
    stopColor: "#A1624A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#8D452D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8897,
    stopColor: "#7F3018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9461,
    stopColor: "#77230B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#741F07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1676_9667",
    x1: 181.256,
    y1: 333.156,
    x2: 305,
    y2: 212.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065768,
    stopColor: "#C5937B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0198,
    stopColor: "#C79882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2898,
    stopColor: "#E5E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA99C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1676_9667",
    x1: 164.98,
    y1: 94.5674,
    x2: 221.118,
    y2: 33.9403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA99C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1676_9667",
    x1: 428.551,
    y1: 338.606,
    x2: 484.689,
    y2: 277.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA99C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1676_9667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 484.629,
    height: 302.138,
    fill: "white",
    transform: "translate(122.979) rotate(23.8185)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHanhtinh);
export default __webpack_public_path__ + "static/media/hanhtinh.a482f913e75cd136e5766dd2f5c45414.svg";
export { ForwardRef as ReactComponent };